import { render, staticRenderFns } from "./HabitacionesServicios.vue?vue&type=template&id=b5911bae"
import script from "./HabitacionesServicios.vue?vue&type=script&lang=js"
export * from "./HabitacionesServicios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports